module.exports = __webpack_public_path__ + "static/media/dra.2e1f3bb6.mp3";